import { UseQueryOptions } from 'react-query';
import httpClient from '../../helpers/http';
import { appConfig } from '../../config/appConfig';

export const GetMySubscriptionPages = (): UseQueryOptions<string[]> => ({
  queryKey: [`MySubscriptionPages`],
  queryFn: () => httpClient.get(`${appConfig.api}/api/subscriptions/my/pages`),
});
